import { useCreateSlide } from '../../api-http/slides-v2';
import { AlertBar } from '../../components/AlertBar';
import devices from '../../components/canvas-editor-v2/assets/devices.json';
import { formMsg } from '../../configs';
import { getDefaultProjectDataV2 } from '../../util/getDefaultProjectData';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as yup from 'yup';

interface SlideFormProps {
  onFinished: () => void;
}

const validationSchema = yup.object({
  title: yup.string().required(formMsg.TITLE_REQUIRED),
});

const Container = styled.div`
  display: flex;
  padding-top: 18px;
  padding-bottom: 18px;
  flex-direction: column;
`;

export const SlideForm: FC<SlideFormProps> = ({ onFinished }) => {
  const navigate = useNavigate();
  const { isLoading, mutate, error, data } = useCreateSlide();

  useEffect(() => {
    if (data?._id) {
      onFinished();
      navigate(`/editor-v2/${data?._id}`);
    }
  }, [data]);

  const formik = useFormik({
    initialValues: {
      title: '',
      deviceType: devices[0].id,
      status: true,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const deviceInfo =
        devices.find((d) => d.id == values.deviceType) || devices[0];
      const projectData = {
        name: values.title,
        used: 1,
        projectData: getDefaultProjectDataV2(deviceInfo),
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { deviceType: _deviceType, ...rest } = values;
      mutate({
        ...rest,
        projectData: projectData?.projectData,
        dynamicData: [],
      });
    },
  });

  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <AlertBar severity="error" msg={error?.msg} mb={2} />
        <TextField
          fullWidth
          id="title"
          name="title"
          label="Slide Title"
          value={formik.values.title}
          onChange={formik.handleChange}
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
          style={{ marginBottom: 10 }}
        />
        <FormControl sx={{ width: '100%', minWidth: 200, marginTop: 2 }}>
          <InputLabel id="role">Screen Size</InputLabel>
          <Select
            fullWidth
            id="deviceType"
            name="deviceType"
            value={formik.values.deviceType}
            label="Device Type"
            title="Device Type"
            placeholder="Device Type"
            onChange={formik.handleChange}
            style={{ marginBottom: 10 }}
          >
            {devices.map((device) => (
              <MenuItem key={device.id} value={device.id}>
                {device.name} - ({device.type})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <LoadingButton
          color="primary"
          disabled={!formik.values.title}
          variant="contained"
          fullWidth
          type="submit"
          loading={isLoading}
        >
          Create
        </LoadingButton>
      </form>
    </Container>
  );
};
